import React from 'react';

interface StatusViewProps {
    green?: string,
    red?: string,
    orange?: string,
    status: string,
    blue?: string,
    indigo?: string
}

const StatusView = ({ red, green, orange, blue, status, indigo }: StatusViewProps) => {
    const lowerStatus = status?.toLowerCase();

    const isRed = red?.toLowerCase().split(',').map(s => s.trim()).includes(lowerStatus);
    const isGreen = green?.toLowerCase().split(',').map(s => s.trim()).includes(lowerStatus);
    const isOrange = orange?.toLowerCase().split(',').map(s => s.trim()).includes(lowerStatus);
    const isBlue = blue?.toLowerCase().split(',').map(s => s.trim()).includes(lowerStatus);
    const isIndigo = indigo?.toLowerCase().split(',').map(s => s.trim()).includes(lowerStatus);

    return (
        <div>
            {isRed ? (
                <div className="flex items-center justify-center bg-red-200 text-bold rounded-full text-center px-3 py-1">{status}</div>
            ) : isGreen ? (
                <div className="flex items-center justify-center bg-green-200 text-bold rounded-full text-center px-3 py-1">{status}</div>
            ) : isOrange ? (
                <div className="flex items-center justify-center bg-orange-200 text-bold rounded-full text-center px-3 py-1">{status}</div>
            ) : isBlue ? (
                <div className="flex items-center justify-center bg-blue-200 text-bold rounded-full text-center px-3 py-1 ">{status}</div>
            ) : isBlue ? (
                <div className="flex items-center justify-center bg-indigo-200 text-bold rounded-full text-center px-3 py-1">{status}</div>
            ) : (
                <div className="flex items-center justify-center bg-yellow-200 text-bold text-center px-3 py-1 rounded-full">
                    {status}
                </div>
            )}
        </div>
    );
}

export default StatusView;
